/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Start_Five_TitleInputs */

const en_us2_clubs_start_five_title = /** @type {(inputs: Clubs_Start_Five_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with 5 friends`)
};

const pt_br2_clubs_start_five_title = /** @type {(inputs: Clubs_Start_Five_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comece com 5 amigos`)
};

const es_419_clubs_start_five_title = /** @type {(inputs: Clubs_Start_Five_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empieza con 5 amigos`)
};

const pt_pt2_clubs_start_five_title = /** @type {(inputs: Clubs_Start_Five_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começa com 5 amigos`)
};

const fr_fr2_clubs_start_five_title = /** @type {(inputs: Clubs_Start_Five_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commence avec 5 amis`)
};

const de_de2_clubs_start_five_title = /** @type {(inputs: Clubs_Start_Five_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starte mit 5 Freunden`)
};

const it_it2_clubs_start_five_title = /** @type {(inputs: Clubs_Start_Five_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia con 5 amici`)
};

/**
* | output |
* | --- |
* | "Start with 5 friends" |
*
* @param {Clubs_Start_Five_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_start_five_title = /** @type {((inputs?: Clubs_Start_Five_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Start_Five_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_start_five_title(inputs)
	if (locale === "es-419") return es_419_clubs_start_five_title(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_start_five_title(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_start_five_title(inputs)
	if (locale === "de-DE") return de_de2_clubs_start_five_title(inputs)
	if (locale === "it-IT") return it_it2_clubs_start_five_title(inputs)
	return en_us2_clubs_start_five_title(inputs)
});
export { clubs_start_five_title as "clubs.start_five_title" }